var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyportfoliodesigncopy08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1A1A1A;}\n\t.st2{fill:#FED631;}\n\t.st3{fill:#FFFFFF;stroke:#1A1A1A;stroke-width:17;stroke-miterlimit:10;}\n\t.st4{fill:#FED631;stroke:#1A1A1A;stroke-width:12;stroke-miterlimit:10;}\n\t.st5{fill:#FED631;stroke:#1A1A1A;stroke-width:4;stroke-miterlimit:10;}\n\t.st6{fill:#1A1A1A;stroke:#1A1A1A;stroke-width:2;stroke-miterlimit:10;}\n\t.st7{fill:#FED631;stroke:#212121;stroke-width:12;stroke-miterlimit:10;}\n\t.st8{fill:#1A1A1A;stroke:#1A1A1A;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M721.9,680.2H144.6c-50.9,0-92.2-41.3-92.2-92.2V232.7c0-50.9,41.3-92.2,92.2-92.2h577.3 c50.9,0,92.2,41.3,92.2,92.2v355.2C814.1,638.9,772.8,680.2,721.9,680.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M726.7,690.1h-587c-53.7,0-97.3-43.7-97.3-97.3V227.9c0-53.7,43.7-97.3,97.3-97.3h587 c53.7,0,97.3,43.7,97.3,97.3v364.9C824.1,646.5,780.4,690.1,726.7,690.1z M139.7,150.5c-42.7,0-77.4,34.7-77.4,77.4v364.9 c0,42.7,34.7,77.4,77.4,77.4h587c42.7,0,77.4-34.7,77.4-77.4V227.9c0-42.7-34.7-77.4-77.4-77.4H139.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1055.4,854.3H524.6c-50.9,0-92.2-41.3-92.2-92.2V439.8c0-50.9,41.3-92.2,92.2-92.2h530.8 c50.9,0,92.2,41.3,92.2,92.2V762C1147.6,813,1106.4,854.3,1055.4,854.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1060.3,864.2H519.8c-53.7,0-97.3-43.7-97.3-97.3v-332c0-53.7,43.7-97.3,97.3-97.3h540.5 c53.7,0,97.3,43.7,97.3,97.3v332C1157.6,820.6,1114,864.2,1060.3,864.2z M519.8,357.5c-42.7,0-77.4,34.7-77.4,77.4v332 c0,42.7,34.7,77.4,77.4,77.4h540.5c42.7,0,77.4-34.7,77.4-77.4v-332c0-42.7-34.7-77.4-77.4-77.4H519.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.7,643.2h-95.5c-1.9,0-3.4-1.5-3.4-3.4V332.3c0-1.9,1.5-3.4,3.4-3.4h95.5c1.9,0,3.4,1.5,3.4,3.4v307.6 C220.1,641.7,218.6,643.2,216.7,643.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M407.7,471.3H273.1c-1.9,0-3.4-1.5-3.4-3.4V332.3c0-1.9,1.5-3.4,3.4-3.4h134.5c1.9,0,3.4,1.5,3.4,3.4v135.6 C411.1,469.7,409.5,471.3,407.7,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M379.2,642.2h-95.5c-1.9,0-3.4-1.5-3.4-3.4V505.3c0-1.9,1.5-3.4,3.4-3.4h95.5c1.9,0,3.4,1.5,3.4,3.4v133.5 C382.6,640.7,381.1,642.2,379.2,642.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M589.1,813.1h-94.5c-1.9,0-3.4-1.5-3.4-3.4V523.2c0-1.9,1.5-3.4,3.4-3.4h94.5c1.9,0,3.4,1.5,3.4,3.4v286.5 C592.5,811.6,591,813.1,589.1,813.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M762.1,653.8H641.3c-1.9,0-3.4-1.5-3.4-3.4v-124c0-1.9,1.5-3.4,3.4-3.4h120.8c1.9,0,3.4,1.5,3.4,3.4v124 C765.6,652.3,764,653.8,762.1,653.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M736.8,811h-89.2c-1.9,0-3.4-1.5-3.4-3.4V684.6c0-1.9,1.5-3.4,3.4-3.4h89.2c1.9,0,3.4,1.5,3.4,3.4v122.9 C740.2,809.5,738.7,811,736.8,811z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1075.5,807.8h-258c-1.9,0-3.4-1.5-3.4-3.4v-40.7c0-1.9,1.5-3.4,3.4-3.4h258c1.9,0,3.4,1.5,3.4,3.4v40.7 C1078.9,806.3,1077.4,807.8,1075.5,807.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1075.5,727.6h-258c-1.9,0-3.4-1.5-3.4-3.4v-40.7c0-1.9,1.5-3.4,3.4-3.4h258c1.9,0,3.4,1.5,3.4,3.4v40.7 C1078.9,726.1,1077.4,727.6,1075.5,727.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1071.3,653.8H817.5c-1.9,0-3.4-1.5-3.4-3.4V527.4c0-1.9,1.5-3.4,3.4-3.4h253.8c1.9,0,3.4,1.5,3.4,3.4v122.9 C1074.7,652.3,1073.1,653.8,1071.3,653.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1079.7,456.5H852.1c-1.9,0-3.4-1.5-3.4-3.4v-67c0-1.9,1.5-3.4,3.4-3.4h227.6c1.9,0,3.4,1.5,3.4,3.4v67 C1083.1,455,1081.6,456.5,1079.7,456.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M743.1,260.3H498.9c-1.9,0-3.4-1.5-3.4-3.4v-68.1c0-1.9,1.5-3.4,3.4-3.4h244.3c1.9,0,3.4,1.5,3.4,3.4v68.1 C746.6,258.7,745,260.3,743.1,260.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.6,
    y: 274.6,
    className: "st1",
    width: 767.3,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.6,
    y: 472.2,
    className: "st1",
    width: 721.6,
    height: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 363.6,
    cy: 212.1,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 260.9,
    cy: 212.1,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 158.2,
    cy: 212.1,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 749.7,
    cy: 416.4,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 647,
    cy: 416.4,
    r: 28.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 544.3,
    cy: 416.4,
    r: 28.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M835.3,1147H364.7c-10.1,0-18.3-8.2-18.3-18.3l0,0c0-10.1,8.2-18.3,18.3-18.3h470.7c10.1,0,18.3,8.2,18.3,18.3 l0,0C853.6,1138.8,845.4,1147,835.3,1147z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyportfoliodesigncopy08);
export default __webpack_public_path__ + "static/media/my portfolio design copy-08.9f60586dd6ab48c37d5ee59f0e91536a.svg";
export { ForwardRef as ReactComponent };